exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hint[data-v-0c0691d8]{color:#666}.error[data-v-0c0691d8]{color:red}.error[data-v-0c0691d8],.hint[data-v-0c0691d8]{font-size:.75em;line-height:normal;margin-bottom:1em}.bitcoin-icon[data-v-0c0691d8]{margin-top:-.5rem;margin-bottom:.5rem}", ""]);

// exports
